import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useEffect } from 'react';
import useIsMobile from '../hooks/useIsMobile';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const serif = 'Playfair Display, serif';
const body = 'Cormorant Garamond, serif';

function Home() {
  const isMobile = useIsMobile();

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Cormorant+Garamond:wght@300;400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', fontFamily: body, color: '#2a1a1a' }}>
      <Navbar />
      <div style={{ textAlign: 'center', padding: isMobile ? '60px 24px 80px' : '80px 40px 100px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '40px' }}>
          <div style={{ height: '1px', width: '30px', backgroundColor: red }}></div>
          <div style={{ height: '1px', width: '10px', backgroundColor: red }}></div>
          <p style={{ color: red, fontSize: '11px', letterSpacing: '4px', margin: 0 }}>CHICAGOLAND — EST. 2025</p>
          <div style={{ height: '1px', width: '10px', backgroundColor: red }}></div>
          <div style={{ height: '1px', width: '30px', backgroundColor: red }}></div>
        </div>
        <h2 style={{ fontFamily: serif, fontSize: isMobile ? '56px' : '80px', fontWeight: '700', color: dark, margin: '0 0 8px', lineHeight: '1' }}>
          HERMES
        </h2>
        <p style={{ letterSpacing: isMobile ? '6px' : '12px', fontSize: '13px', color: dark, margin: '0 0 30px', fontWeight: '300' }}>
          PARTNER CAPITAL
        </p>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', margin: '20px 0 30px' }}>
          <div style={{ height: '1px', width: '80px', backgroundColor: '#c9a882' }}></div>
          <div style={{ width: '6px', height: '6px', backgroundColor: '#c9a882', transform: 'rotate(45deg)' }}></div>
          <div style={{ height: '1px', width: '80px', backgroundColor: '#c9a882' }}></div>
        </div>
        <p style={{ fontFamily: serif, fontStyle: 'italic', fontSize: isMobile ? '18px' : '22px', margin: '0 0 20px', color: '#2a1a1a' }}>
          "Fortune Favors the Bold"
        </p>
        <p style={{ fontSize: '16px', color: '#555', maxWidth: '500px', margin: '0 auto 50px', lineHeight: '1.8', fontWeight: '300' }}>
          We help local businesses grow with AI. Smarter systems, faster follow-up, and more revenue — without hiring more staff.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
          <a href="/contact" style={{ backgroundColor: red, color: bg, padding: '18px 60px', textDecoration: 'none', fontSize: '11px', letterSpacing: '3px', display: 'block', width: isMobile ? '260px' : '300px', textAlign: 'center' }}>
            REQUEST A CONSULTATION
          </a>
          <a href="/services" style={{ backgroundColor: 'transparent', color: red, padding: '17px 60px', textDecoration: 'none', fontSize: '11px', letterSpacing: '3px', border: '1px solid #6B1A1A', display: 'block', width: isMobile ? '260px' : '300px', textAlign: 'center' }}>
            SEE OUR SERVICES
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;